module.exports = __webpack_public_path__ + "static/media/top-img_3_mob@2x.ecab0691.png";